import { CSSProperties } from "react";

export const fixedCellStyle: CSSProperties = { whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" };
